export default "__VITE_ASSET__CJrxtcwf__"